import React from 'react'

const InternalServer = () => {
    return (
        <div>InternalServer</div>
    )
}

export default InternalServer
